document.addEventListener('DOMContentLoaded', () => {
  const hamburgerArea = document.querySelector('.header-sp__hamburger-container');
  const hamburgerIcon = document.querySelector('.header-sp__hamburger');
  const menu = document.querySelector('.header-sp__menu');

  hamburgerArea.addEventListener('click', () => {
    hamburgerIcon.classList.toggle('is-active');
    menu.classList.toggle('is-active');
  });
});
